export const environment = {
  production: false,
  clientId: '2f5a47c6-14e1-4699-98c6-3c60de043280',
  frontEndUrl: 'https://ktcs-frontend-deva51.azurewebsites.net/',
  baseURL: 'https://ktcs-clsf-svc-deva51.azurewebsites.net/',
  buildInfo: 'v2.0.01787132981',
};
